<template>
    <header class="header-global">

        <div class="locale-changer">

        </div>

    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import CloseButton from "@/components/CloseButton";

export default {
    data () {
        return {

        }
    },
    components: {
        BaseNav,
        CloseButton
    },
    methods: {
    }
};
</script>
